export const NEIGHBOR_STAINS_INPUT_KEY = 'neighbor_stains';
export const TARGET_STAINS_INPUT_KEY = 'target_stains';
export const DEPENDENT_ON_INPUT_TYPE = 'dependent_field_selected_value_type';
